function DivTdsBody01({ children }) {
  return <p className={'tds-body-01'}>{children}</p>;
}

export default DivTdsBody01;
